import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('updateUserForm');

    return {
        EMAIL_ADDRESS_FIELD_PLACEHOLDER: t('emailAddressFieldPlaceholder'),
        FIRST_NAME_FIELD_PLACEHOLDER: t('firstNameFieldPlaceholder'),
        LAST_NAME_FIELD_PLACEHOLDER: t('lastNameFieldPlaceholder'),
        PHONE_NUMBER_FIELD_PLACEHOLDER: t('phoneNumberFieldPlaceholder'),
        SAVE: t('save')
    };
};

export default useTranslation;
